import React from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Sparkles } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "./ui/button";

const MODULE_LABELS = {
  dispatch: "Dispatch Board",
  pipeline: "Sales Pipeline",
  pricebook: "Pricebook & Inventory",
  reports: "Reports & Analytics",
  marketing: "Marketing",
  automations: "Automations",
  mobile_tech: "Mobile Tech App",
  memberships: "Memberships",
  online_payments: "Online Payments",
  messaging: "Team Messaging",
  inbox: "Customer Inbox",
  timeclock: "Timeclock & Payroll",
  guru: "Diagnostic Guru",
  flow_ai: "AI Flow Builder",
  voice_ai: "Voice AI Simulator",
  ai_agents: "AI Voice Agents",
  calendar: "Calendar",
  fleet_tracking: "Live Fleet & GPS Tracking",
  job_completion: "Job Completion Flow",
  photo_signature: "Photo Capture & E-Signature",
  onboarding_checklists: "Guided Onboarding Checklists",
  public_accept_pages: "Public Accept, Sign & Deposit Pages",
  ai_email_designer: "AI Email Designer",
  email_builder: "Drag-and-Drop Email Builder",
  form_builder: "Form Builder & Public Forms",
  ai_diagnostics: "AI Diagnostic Assistant",
  ai_knowledge_base: "AI Knowledge Base",
  google_sso: "Google Sign-In SSO",
  bulk_csv_invites: "Bulk CSV Team Invites",
};

/** Full-page lock shown when the company's plan doesn't include a module. */
export function UpgradeLocked({ module }) {
  const navigate = useNavigate();
  const label = MODULE_LABELS[module] || "This feature";
  return (
    <div className="flex items-center justify-center min-h-[70vh] p-6" data-testid="upgrade-locked">
      <div className="max-w-md w-full text-center rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
        <div className="h-14 w-14 rounded-2xl bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center mx-auto mb-4">
          <Lock className="h-6 w-6 text-white" />
        </div>
        <h2 className="text-[18px] font-bold text-slate-900">{label} is not in your plan</h2>
        <p className="text-[13.5px] text-slate-500 mt-2 leading-relaxed">
          Upgrade your subscription to unlock {label.toLowerCase()} and get more out of ServiceGuru Pro.
        </p>
        <Button
          onClick={() => navigate("/settings/billing")}
          data-testid="upgrade-cta"
          className="mt-5 h-10 px-5 bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-400 hover:to-orange-500 text-white text-[13.5px] font-semibold"
        >
          <Sparkles className="h-4 w-4 mr-1.5" /> Upgrade your plan
        </Button>
      </div>
    </div>
  );
}

/** Gate a route/page behind a plan module. Renders children if entitled. */
export function ModuleGate({ module, children }) {
  const { hasModule } = useAuth();
  if (hasModule(module)) return children;
  return <UpgradeLocked module={module} />;
}

export default ModuleGate;
